/**
 * Service for checking bulk compatibility.
 * Needs bulk_matrix_compatibility component in Wels and a matrix set..Only available for ConocoPhillips pr 14.11.2016.
 *
 */

var VRC = VRC || {};
VRC.BulkCompatibility = (function() {
  var _ruleWrapper = {};

  var init = function() {
    _ruleWrapper = g_master_data.master_data.bulk_matrix;
  };

  var canMixBulk = function(leftItemType, rightItemType) {
      var wrapper;

      if(_ruleWrapper && _ruleWrapper.matrix){
          var row = _ruleWrapper.matrix[leftItemType];
          var column = row ? row[rightItemType] : undefined;
          var rule = column ? _ruleWrapper.rules[column.rule] : _ruleWrapper.rules.none;

          wrapper = {rule: rule};
          if (column) {
              wrapper.data = column;
          }
      }
      return wrapper;
  };

    var hasComponent = function(){
      var hasComponent = false;
      if(_ruleWrapper){
        if(_ruleWrapper.matrix){
          hasComponent =  _.isEmpty(_ruleWrapper.matrix) === false;
        }
      }
      return hasComponent;
    };

    var getRuleList = function() {
        return _.keys(_ruleWrapper.rules);
    };

    return {
        canMixBulk: canMixBulk,
        hasComponent : hasComponent,
        getRuleList: getRuleList,
        init: init
    };
})();
